<div class="component-image" (mouseenter)="fetchComponentImage()" (mouseleave)="showImage = false">
    <ng-container *ngIf="imageFileName; else previewPlaceholder">
        <img class="preview" [appFetchComponentImage]="imageFileName" alt="Komponens kép">
    </ng-container>
    <ng-template #previewPlaceholder>
        <span class="preview preview--placeholder"></span>
    </ng-template>
    <div class="image-wrapper" *ngIf="showImage">
        <ng-container *ngIf="imageSafeUrl && !imageLoadFailed; else imagePlaceholder">
            <img [src]="imageSafeUrl" alt="Komponens kép">
        </ng-container>
        <ng-template #imagePlaceholder>
            <div class="image-placeholder">
                <span>{{ fetchingImage ? 'Betöltés…' : 'Nincs kép' }}</span>
            </div>
        </ng-template>
    </div>
</div>
